import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import Listing from './listing/Listing'
import Request from './request/Request'
import LeavePolicyManager from './LeavePolicyManager'
import EmployeeBalances from './EmployeeBalances'

const tabBtnClass = 'inline-block py-3 px-6 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-blue-600 text-blue-600'
const tabBorderNoneClass = 'border-transparent'

const TAB_LISTING = 'listing'
const TAB_REQUEST = 'request'
const TAB_POLICIES = 'policies'
const TAB_BALANCES = 'balances'

const LeaveManager = () => {
  const { t } = useTranslation()
  const [defaultTab, setDefaultTab] = useState('listing')

  const handleTabClick = (action) => {
    setDefaultTab(action)
  }

  const renderTabContent = () => {
    switch (defaultTab) {
      case TAB_LISTING:
        return <Listing />
      case TAB_REQUEST:
        return <Request setDefaultTab={setDefaultTab} />
      case TAB_POLICIES:
        return <LeavePolicyManager />
      case TAB_BALANCES:
        return <EmployeeBalances />
      default:
        return null
    }
  }

  return (
    <div className='py-5 px-6'>
      <div className='py-3 my-2'>
        <ul className='border-b flex flex-wrap gap-1'>
          <li>
            <button
              onClick={() => handleTabClick(TAB_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_LISTING
              })}
            >
              {t('LISTING')}
            </button>
          </li>
          <li>
            <button
              onClick={() => handleTabClick(TAB_REQUEST)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_REQUEST,
                [tabBorderNoneClass]: defaultTab !== TAB_REQUEST
              })}
            >
              {t('REQUEST')}
            </button>
          </li>
          <li>
            <button
              onClick={() => handleTabClick(TAB_POLICIES)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_POLICIES,
                [tabBorderNoneClass]: defaultTab !== TAB_POLICIES
              })}
            >
              {t('LEAVE_POLICIES')}
            </button>
          </li>
          <li>
            <button
              onClick={() => handleTabClick(TAB_BALANCES)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_BALANCES,
                [tabBorderNoneClass]: defaultTab !== TAB_BALANCES
              })}
            >
              {t('EMPLOYEE_BALANCES')}
            </button>
          </li>
        </ul>
      </div>
      {renderTabContent()}
    </div>
  )
}

export default LeaveManager